import io from '../../node_modules/socket.io-client/dist/socket.io';
import {generateRandomString, getCookie, setCookie} from "@/helperFunctions";

class VorbasseSocket
{
	install(vue)
	{
		vue.prototype.$vorbasseSocket = this;
		this.socket = false;
		this.hasEnsured = false;
		this.token = false;
		this.url = (typeof process !== 'undefined' && typeof process.env !== 'undefined' && typeof process.env.VUE_APP_SOCKET_URL !== 'undefined') ? process.env.VUE_APP_SOCKET_URL : false;
		this.commands = {};
	}
	
	setToken(token)
	{
		if (typeof token === 'string' || token === false)
		{
			this.token = token;
		}
	}
	
	ensureSocket(type, callback)
	{
		return false;
		if (this.url === false)
		{
			this.destroy();
			return false;
		}
		
		if (this.hasEnsured)
		{
			if (typeof callback === 'function')
			{
				callback(this.socket);
			}
			return true;
		}
		
		this.hasEnsured = true;
		
		let mac = getCookie('vb_mc');
		if(mac === undefined)
		{
			mac = generateRandomString(20);
			setCookie('vb_mc',mac,365*24);
		}
		
		let headers = {'x-socket-type': type,'x-mac':mac};
		if(this.token !== false)
			headers['x-token'] = this.token;
		
		this.socket = io(this.url, {
			transportOptions: {
				polling: {
					extraHeaders: headers
				}
			}
		});
		
		this.initCommandListener();
		
		if (typeof callback === 'function')
		{
			callback(this.socket);
		}
	}
	
	destroy()
	{
		if (this.socket !== false)
		{
			this.socket.close();
			this.socket = false;
			this.hasEnsured = false;
			this.token = false;
			this.commands = {};
		}
	}
	
	listen(channel, callback)
	{
		if (this.socket !== false)
		{
			this.socket.on(channel, (data) =>
			{
				callback(data)
			});
		}
	}
	
	stopListening(channel)
	{
		if (this.socket !== false)
		{
			this.socket.off(channel);
		}
	}
	
	emit(channel, message)
	{
		this.socket.emit(channel, message)
	}
	
	
	/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                COMMANDS
	 
	 ************************************************************************/
	
	/**
	 * Commands should be used when you expect exactly 1 response, or when multiple things should be listening to the same key.
	 */
	initCommandListener(){
		this.socket.on('command-result',(payload) => {
			if(typeof payload.type !== 'undefined' && typeof this.commands[payload.type] !== 'undefined')
			{
				Object.keys(this.commands[payload.type]).forEach(id => {
					this.commands[payload.type][id](payload);
				})
			}
		});
	}
	
	onCommand(type, callback)
	{
		if(typeof this.commands[type] !== 'object')
			this.commands[type] = {};
		
		let key = generateRandomString(10);
		while(typeof this.commands[type][key] !== 'undefined')
		{
			key = generateRandomString(10);
		}
		
		this.commands[type][key] = callback;
		return key;
	}
	
	dropCommandListener(type, key)
	{
		if(typeof this.commands[type] === 'object' && typeof this.commands[type][key] !== 'undefined')
		{
			delete this.commands[type][key];
			if(Object.keys(this.commands[type]).length === 0)
				delete this.commands[type]
		}
	}
}

const vorbasseSocket = new VorbasseSocket();
export default vorbasseSocket;
